module.exports = __webpack_public_path__ + "media/images/responsive/page_common/wave_top-995f16f81aebf5a484bc1a8363b11216.png";